module.exports = {"userInfoText":"帐户信息","logoutText":"退出登录","userLang":"簡体中文","language":"語言","group":"群組","languageItem":{"en-US":"English","zh-TW":"繁體中文","zh-CN":"簡体中文"},"en-US":"English","zh-TW":"繁體中文","zh-CN":"簡体中文","themeText":"皮肤","Mobile":{"userLang":"簡"},"selectPlaceholder":"请选择","selectTimePlaceholder":"选择时间","selectNotFoundText":"无匹配数据","tableNoDataText":"暂无数据","tableNoFilteredDataText":"暂无筛选结果"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/main.json
// module id = dQtP
// module chunks = 3